// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"234":"preload","532":"styles"}[chunkId] + "." + {"234":"994d861e57721672c3f8","532":"bb85f3b42c494c8f311e"}[chunkId] + ".css";
};